import { render, staticRenderFns } from "./NetworkEth0.vue?vue&type=template&id=c0fe58c2&"
import script from "./NetworkEth0.vue?vue&type=script&lang=js&"
export * from "./NetworkEth0.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/cristiano/workspace/gw-frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VSlideYTransition } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VCardTitle,VSlideYTransition,VSwitch,VTextField})
